import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, withStyles } from '@material-ui/core';
import { Button, Typography, TextInput } from 'kangarootime-ui';
import { Query } from 'react-apollo';
import { GET_CHANNEL_MEMBERS } from '../../graphql/queries';
import MemberList from './MemberList/MemberList';

const styles = theme => ({
  root: {
    margin: 0,
    padding: 24
  }
});

const ChannelMembersDialog = ({
  isOpen,
  onClose,
  channelId,
  canInviteAdditionalMembers,
  showInviteAdditonalMembersModal,
  ...props
}) => {
  const [filterValue, setFilterValue] = useState('');

  if (!isOpen) {
    return null;
  }

  return (
    <Dialog
      fullWidth
      open={isOpen}
      onClose={onClose}
      maxWidth='sm'
    >
      <Query
        query={GET_CHANNEL_MEMBERS}
        variables={{ channelId }}
        fetchPolicy='cache-first'
      >
        {({ loading, error, data }) => {
          if (loading) return null;

          const members = data.getChannelMembers || [];
          const filteredMembers = members.filter(user => user.name.toLowerCase().includes(filterValue));

          return (
            <DialogContent className={props.classes.root}>
              <Typography type='bold' style={{ fontSize: 18 }}>{members.length} members in this channel</Typography>
              <TextInput
                placeholder='Search members'
                value={filterValue}
                onChange={event => setFilterValue(event.target.value)}
                style={{ marginBottom: 16 }}
              />
              <MemberList members={filteredMembers} />
              { canInviteAdditionalMembers &&
                <div className='flex' style={{ justifyContent: 'flex-end' }}>
                  <Button
                    onClick={showInviteAdditonalMembersModal}
                    style={{ alignSelf: 'flex-end' }}
                  >
                    Add People
                  </Button>
                </div>
              }
            </DialogContent>
          );
        }}
      </Query>
    </Dialog>
  );
};

ChannelMembersDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  channelId: PropTypes.string,
  canInviteAdditionalMembers: PropTypes.bool,
  showInviteAdditonalMembersModal: PropTypes.func
};

ChannelMembersDialog.defaultProps = {
  canInviteAdditionalMembers: true
};

export default withStyles(styles)(ChannelMembersDialog);
